import React from 'react'
interface Props {
  children: React.ReactNode
}
const ContainerWrapper = ({children}: Props) => {
  return (
    <div className={'panel__container'}>
      <div className={'panel__container__flex'}>{children}</div>
    </div>
  )
}

export default ContainerWrapper
